import { DesktopGridItem } from 'shared/types/desktop-grid'

import { applySequentialPlacement } from './applySequentialPlacement'
import { AutoArrangeHandler } from './types'

const getSortType = (item: DesktopGridItem): string => item.fileType ?? ''

export const arrangeItemsByType: AutoArrangeHandler = (items, cols, rows) => {
  const sortedItems = [...items].sort((a, b) => {
    const typeA = getSortType(a)
    const typeB = getSortType(b)

    if (typeA !== typeB) {
      return typeA.localeCompare(typeB)
    }

    // if same type, sort by label
    return a.label.localeCompare(b.label)
  })

  return applySequentialPlacement(sortedItems, cols, rows, items)
}
